import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import MainPage from './routes/Main';
import { UserProvider } from './contexts/UserContext';

const AppRouter = () => {
  return (
    <Router>
      <UserProvider>
        <Routes>
          <Route path="/" element={<MainPage />} />
        </Routes>
      </UserProvider>
    </Router>
  );
};

export default AppRouter;